import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button, IconButton } from '@xingternal/button';
import { IconArrowLeft, IconCross } from '@xingternal/icons';
import { Headline, Meta } from '@xingternal/typography';

import * as S from './task-header.styles';

type CommonProps = {
  title: JSX.Element;
  subtitle?: JSX.Element;
  backDisabled?: boolean;
};

type ConditionalProps =
  | { onClose: () => void; onSave: () => void; onBack?: never }
  | { onClose?: never; onSave?: never; onBack: () => void };

type Props = CommonProps & ConditionalProps;

export const TaskHeader: React.VFC<Props> = ({ title, subtitle, backDisabled, onClose, onBack, onSave }) => {
  const { formatMessage } = useIntl();

  return (
    <S.Container>
      <IconButton
        icon={onClose ? IconCross : IconArrowLeft}
        disabled={backDisabled}
        onClick={onClose ?? onBack}
        aria-label={formatMessage({ id: onClose ? 'BUTTON_CLOSE' : 'BUTTON_BACK' })}
        data-cy="task-header-back-button"
      />
      <S.Title>
        <Headline size="large" noMargin>
          {title}
        </Headline>
        {subtitle && (
          <Meta size="small" noMargin>
            {subtitle}
          </Meta>
        )}
      </S.Title>
      {onSave ? (
        <Button variant="primary" size="small" onClick={onSave}>
          <FormattedMessage id="BUTTON_SAVE" />
        </Button>
      ) : (
        <S.PlaceboButton />
      )}
    </S.Container>
  );
};
